/**
 * BRK-1921: evaluations are reform-only — the portal must never fall back to a JotForm iframe for
 * them. Three separate surfaces decide between <ReForm> and the legacy iframe
 * (create-document-preview, edit-document-preview, therapist-dashboarb-doc-edit), so the set of
 * "this is an evaluation" form types lives here rather than being re-spelled in each one.
 *
 * Exact matching is deliberate: TRANSITIONAL_EVALUATION_REFORM_PT *contains* the substring
 * EVALUATION_REFORM_PT, so an `includes` check would silently pull the transitional evaluation
 * flow into the reform-only severance. Transitional evaluations keep their own flag-gated
 * behaviour and are intentionally NOT part of this set.
 */
const EVAL_FORM_TYPES = new Set([
  // Legacy JotForm evaluations — no longer offered for creation, but existing documents remain.
  'EVALUATION_PT',
  'EVALUATION_OT',
  'EVALUATION_SLP',
  // Reform evaluations.
  'EVALUATION_REFORM_PT',
  'EVALUATION_REFORM_OT',
  'EVALUATION_REFORM_SLP',
]);

export const isEvalFormType = (formType?: string | null): boolean =>
  !!formType && EVAL_FORM_TYPES.has(formType.trim().toUpperCase());

export default isEvalFormType;
